const inView = (elem, offset = 0) => {
    const elemTop = elem.offset().top + offset;
    const windowBottom = $(window).scrollTop() + $(window).height();

    return ( windowBottom > elemTop ) ? true : false;
};